import { createSlice } from "@reduxjs/toolkit";

const savedPage = localStorage.getItem("CurrentPage");
const userData = localStorage.getItem("UserId");

const initialState = {
  currentPage: !userData ? "Home" : savedPage || "Home",
  selectedProfileId: null,
  Mno: "",
  usrid: "",
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
      localStorage.setItem("CurrentPage", action.payload);
    },
    setSelectedProfileId: (state, action) => {
      state.selectedProfileId = action.payload;
    },
    setMno: (state, action) => {
      state.Mno = action.payload;
    },
    setUsrid: (state, action) => {
      state.usrid = action.payload;
    },
    resetNavigation: (state) => {
      state.currentPage = "Home";
      state.selectedProfileId = null;
      state.Mno = "";
      state.usrid = "";
      localStorage.setItem("CurrentPage", "Home");
    },
  },
});

export const {
  setCurrentPage,
  setSelectedProfileId,
  setMno,
  setUsrid,
  resetNavigation,
} = navigationSlice.actions;

export default navigationSlice.reducer;
